<ng-container>
  <div class="announcements" *ngIf="announcement as data">
    <app-announcement-info
      [ngStyle]="{ width: data.isCreate ? '80%' : '40%' }"
      [announcement]="
        data.isCreate ? data.editedAnnouncement : data.originalAnnouncement
      "
      [isEdited]="false"
      [isCreate]="data.isCreate"
      [changes]="data.changes"
      [products]="data.products"
      [announcementModerationId]="data.announcementModerationId"
      [alternativeLanguage]="alternativeLanguage"
      (refreshPageEvent)="getAnnouncementData(announcementId)"
    ></app-announcement-info>
    <app-announcement-info
      [ngStyle]="{ width: '40%' }"
      *ngIf="!data.isCreate"
      [alternativeLanguage]="alternativeLanguage"
      [announcement]="data.editedAnnouncement"
      [isEdited]="true"
      [isCreate]="data.isCreate"
      [changes]="data.changes"
      [editedDescription]="data.editedDescription"
      [editedDescription2]="data.editedDescription2"
      [products]="data.products"
      [announcementModerationId]="data.announcementModerationId"
      (refreshPageEvent)="getAnnouncementData(announcementId)"
    ></app-announcement-info>
  </div>
</ng-container>
